export default __webpack_public_path__ + "static/media/polyclonal_antibodies.af339dba.png";